import React, { useState, useEffect } from 'react';
import './PrivacyPolicy.css'; 

const Shippingpolicy = () => {
  const [shippingText, setShippingText] = useState("Loading shipping details...");

  useEffect(() => {
    fetch('https://atrmart.in/shipping-policy.txt')
      .then(response => response.text())
      .then(data => setShippingText(data))
      .catch(err => setShippingText("Unable to load Shipping Policy."));
  }, []);

  return (
    <div className="policy-container">
      <header className="policy-header">
        <h1>Shipping Policy</h1>
        <p>ATR AGRO MART | Logistics & Delivery</p>
      </header>
      <section className="policy-content">
        <div style={{ whiteSpace: 'pre-wrap' }}>{shippingText}</div>
      </section>
    </div>
  );
};

export default Shippingpolicy;